import axios from "axios";
const API_BASE = "https://apidash.smartpress.kz/api";

export default {
  namespaced: true,
  state: () => ({ meetings: [] }),
  getters: { all: (s) => s.meetings },
  mutations: {
    SET_MEETINGS(state, meetings) {
      state.meetings = Array.isArray(meetings) ? meetings : [];
    },
  },
  actions: {
    async fetchMeetings({ commit }) {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(`${API_BASE}/riso/meetings`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      commit("SET_MEETINGS", data?.meetings || []);
      return data?.meetings || [];
    },
    async fetchAgenda(_, meetingId) {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(`${API_BASE}/riso/meetings/${meetingId}/books`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    },
  },
};
